export const ACTIVE_ORDERS = "ACTIVE_ORDERS";
export const QR_LOAD = "QR_LOAD";
export const LOAD_DOWNLOAD = "LOAD_DOWNLOAD";
export const MESSAGE = "MESSAGE";
export const PWA = "PWA";

export const REFRESH = "REFRESH";
export const LET_REFRESH = "LET_REFRESH";
export const ORDERS_HISTORY = "ORDERS_HISTORY";
export const CURRENT_ORDER = "CURRENT_ORDER";
export const CURRENT_OFFICE = "CURRENT_OFFICE";
export const OFFICE_AUTH = "OFFICE_AUTH";
export const INVALID_AUTH = "INVALID_AUTH";
export const SUB_ORDERS = "SUB_ORDERS";
export const SEARCH_START_DATE = "START_DATE";
export const SEARCH_END_DATE = "SEARCH_END_DATE";
export const SEARCH_SEARCH_BAR = "SEARCH_BAR";
export const SEARCH_STATE = "SEARCH_STATE";
export const SEARCH_PERPAGE = "SEARCH_PERPAGE";
export const SEARCH_PAGE = "SEARCH_PAGE";
export const STATES = "STATES";
export const SEARCH_NOT_FOUND = "SEARCH_NOT_FOUND";
export const SEARCH_LENGTH = "SEARCH_LENGTH";
export const SEARCH_FILTERED = "SEARCH_FILTERED";
export const LOADING = "LOADING";
export const MODAL_LOADING = "MODAL_LOADING";
export const MESSAGES = "MESSAGES";
export const QRCODE = "QRCODE";
export const READY_TO_SEND = "READY_TO_SEND";
export const REGISTER_MOBILE_EMAIL = "REGISTER_MOBILE_EMAIL";
export const RECOVER_PASS_MESSAGE = "RECOVER_PASS_MESSAGE";
export const RECOVER_CODE = "RECOVER_CODE";
export const CAPTCHA = "CAPTCHA";
export const SHOW_CAPTCHA = "SHOW_CAPTCHA";
export const REGISTER_STAGE = "REGISTER_STAGE";
export const REGISTER_OTP = "REGISTER_OTP";
export const REGISTER_INITIATED = "REGISTER_INITIATED";
export const REGISTER_ADDRESS = "REGISTER_ADDRESS";
export const LNG_LAT = "LNG_LAT";
export const TRACE_CODE = "TRACE_CODE";
export const LOGIN_OTP = "LOGIN_OTP";
export const RESET_CAPTCHA = "RESET_CAPTCHA";
export const SET_ORDERS_LENGTH = "SET_ORDERS_LENGTH";

export const LOGIN_RECOVER_CONTACT = "LOGIN_RECOVER_CONTACT";

export const ClientSideSearch = {
  SEARCH_BAR: "SEARCH_BAR",
  STATE_BAR: "STATE_BARSEARCH_BAR",
  START_DATE: "START_DATE",
  END_DATE: "END_DATE",
};

export const managementActionTypes = {
  newEmployeeInfo: null,
};
